import request from '@/router/axios';
// 列表
export const getList = (current, size, params) => {
  return request({
    url: '/api/blade-demo/demoOrder/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}
// 详情
export const getDetail = (id) => {
  return request({
    url: '/api/blade-demo/demoOrder/detail',
    method: 'get',
    params: {
      id
    }
  })
}
// 新增
export const add = (row) => {
  return request({
    url: '/api/blade-demo/demoOrder/save',
    method: 'post',
    data: row
  })
}
// 修改
export const update = (row) => {
  return request({
    url: '/api/blade-demo/demoOrder/update',
    method: 'post',
    data: row
  })
}
// 删除
export const remove = (ids) => {
  return request({
    url: '/api/blade-demo/demoOrder/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}
// 作废
export const toVoid = (ids) => {
  return request({
    url: '/api/blade-demo/demoOrder/toVoid',
    method: 'post',
    params: {
      ids,
    }
  })
}
// 审核
export const audit = (ids) => {
  return request({
    url: '/api/blade-demo/demoOrder/audit',
    method: 'post',
    params: {
      ids,
    }
  })
}